import { render, staticRenderFns } from "./TotalizadorComercial.vue?vue&type=template&id=548f2ad6"
import script from "./TotalizadorComercial.vue?vue&type=script&lang=js"
export * from "./TotalizadorComercial.vue?vue&type=script&lang=js"
import style0 from "./TotalizadorComercial.vue?vue&type=style&index=0&id=548f2ad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports